import { render } from "./oqc.vue?vue&type=template&id=59aa62a7&scoped=true"
import script from "./oqc.vue?vue&type=script&lang=js"
export * from "./oqc.vue?vue&type=script&lang=js"

import "./oqc.vue?vue&type=style&index=0&id=59aa62a7&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59aa62a7"]])

export default __exports__